<div class=" bg-gray-20 lg:border-b border-gray-300">
    <div class=" container mx-auto lg:mb-10 ">

        <p class="text-xl text-[var(--charcoal)] mt-4"> When you bid on an item, it will be added to My Bids. Items show
            on My Bids until they close and are finalized then they will move to My Purchases. Buy Now and Ticket
            purchases show only under My Purchases
        </p>

    </div>

    <ng-container *ngIf="isLoading() ; else content">


        <div class="flex items-center justify-center min-h-[300px]">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    </ng-container>

    <ng-template #content>


        @if(myBids().length == 0) {
            <div class="w-full mt-8 flex justify-center">
                <div class="bg-white shadow-md rounded-lg text-center max-w-full md:max-w-[60%] mb-16 px-8">
                    <p class="text-xl mx-6 mt-4">You do not have any active bids.</p>
                    <p>Go to <a [routerLink]="['/my-account/my-purchases']" class="text-[var(--p-text-color-primary)]!">My Purchases</a> to see items won or bought.</p>
                </div>
            </div>
        } @else {
            <div class="w-full mt-8">
                <div class="flex justify-end mb-4 lg:mb-8">
                    <p-select [options]="sortFilters" [(ngModel)]="selectedSortSignal" placeholder="Sort by" class="">
                    </p-select>
                </div>

                <app-my-bids-page [myBids]="myBids().length > 10 ? paginatedItems() : sortedItems()"></app-my-bids-page>

            </div>
        }

        @if(myBids().length > 10)
        {
        <p-paginator [rows]="rows()" [first]="first()" [totalRecords]="sortedItems().length"
            [rowsPerPageOptions]="rowsPerPageOptions" (onPageChange)="onPageChange($event)" styleClass="mt-7 text-sm">
        </p-paginator>

        }

    </ng-template>
</div>